module.exports = __webpack_public_path__ + "0c1d027ac4c470adfbeab532f433974b.png";